import axios from "@/lib/axios";

type NewCompanyRequestParams = {
  token: string;
  taxId: string;
  name: string;
  tradeName: string;
  website: string;
  address: {
    street: string;
  };
  mainContact: {
    names: string;
    email: string;
  };
};

type NewCompanyRequestResponse = {
  id: string;
};

export const createCompany = (params: NewCompanyRequestParams) => {
  return axios
    .post<NewCompanyRequestResponse>(`/v1/companies`, params, {
      headers: {
        Authorization: "Bearer " + params.token,
      },
    })
    .then((res) => res.data);
};
